import { useNavigate } from "react-router-dom";
import { useImpersonation } from "@/contexts/ImpersonationContext";
import { AlertTriangle, X } from "lucide-react";
import { Button } from "@/components/ui/button";

/**
 * Non-dismissible yellow banner shown during admin impersonation.
 * Rendered at the top of the app layout.
 */
export const ImpersonationBanner = () => {
  const { impersonation, stopImpersonation } = useImpersonation();
  const navigate = useNavigate();

  if (!impersonation?.active) return null;

  const handleExit = async () => {
    await stopImpersonation();
    navigate("/platform");
  };

  return (
    <div className="sticky top-0 z-[100] flex items-center justify-center gap-3 bg-yellow-400 px-4 py-2 text-yellow-900 text-sm font-medium shadow-md">
      <AlertTriangle className="h-4 w-4 shrink-0" />
      <span>
        You are viewing <strong>{impersonation.tenantName}</strong> as{" "}
        <strong>{impersonation.adminEmail}</strong>. All actions are logged.
      </span>
      <Button
        size="sm"
        variant="outline"
        className="ml-2 h-7 border-yellow-700 bg-yellow-300 text-yellow-900 hover:bg-yellow-200 hover:text-yellow-950"
        onClick={handleExit}
      >
        <X className="h-3 w-3 mr-1" />
        Exit Admin View
      </Button>
    </div>
  );
};
